module.exports = __webpack_public_path__ + "media/giftcards/GC-HowItWorks-1-14820c21.svg";